import React from 'react'
import {Link} from "react-router-dom"
import "./Event.css"
import img1 from "../.././assets/ShortFilm.jpg"
import img2 from "../.././assets/Paper1.jpeg"
import img3 from "../.././assets/Googler.png"
import img4 from "../.././assets/LanGaming1.jpeg"
import img5 from "../.././assets/AUCTION1.jpg"
import img6 from "../.././assets/Drone.png"
const Events = () => {
  return (
    <div className='event_container'>
      <div className="title">
        <h2>EVENTS</h2>
      </div>
      <div className="com_events">
        <div className="evt_container evt1">
          <Link to="/Movie-Mania">
          <img src={img1} alt="" />
          <p>Movie Mania</p>
          </Link>
        </div>
        <div className="evt_container evt2">
          <Link to="/Project-Expo">
          <img src={img2} alt="" />
          <p>Model and Project  Expo</p>
          </Link>
          </div>
        <div className="evt_container evt3">
        <Link to="/Googler">
          <img src={img3} alt="" />
          <p>Googler</p>
          </Link>
        </div>
        <div className="evt_container evt4">
        <Link to="/Lan">
          <img src={img4} alt="" />
          <p>LAN GAMING</p>
          </Link>
        </div>
        <div className="evt_container evt5">
        <Link to="/IPL">
          <img src={img5} alt="" />
          <p>IPL Auction</p>
          </Link>
        </div>
        <div className="evt_container evt6">
        <Link to="/Dronathon">
          <img src={img6} alt="" />
          <p>Dronathon</p>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Events